import React from 'react';

const Service = () => {
  const services = [
    { title: "Product Training", desc: "Learn, adapt and grow with hands-on training sessions.", color: "#ff4500", icon: "👨‍🏫" },
    { title: "Technical Support", desc: "Get quick and reliable support whenever you need it.", color: "#00c853", icon: "🎧" },
    { title: "Customisation", desc: "Tailored solutions designed around your needs.", color: "#ff4500", icon: "🎛️" },
    { title: "Success Manager", desc: "Dedicated experts ensuring your success, every step.", color: "#00c853", icon: "📈" },
    { title: "Design Expert", desc: "Creative designs that brings ideas to life.", color: "#ff4500", icon: "🖥️" },
  ];

  return (
    <section className="ax-step-sec-container">
      <style>
        {`

        `}
      </style>

      <div className="ax-step-sec-wrapper">
        {/* Left Section */}
        <div className="ax-step-content">
          <div className="ax-step-header">
            <h2>With <span className="highlight">You</span>,<br /> Every Step.</h2>
            <div className="ax-step-divider">
              <div className="ax-step-line"></div>
              <span className="ax-step-star">★</span>
              <div className="ax-step-line"></div>
            </div>
          </div>

          <div className="ax-service-list">
            {services.map((service, index) => (
              <div key={index} className="ax-service-card" style={{ color: service.color }}>
                <div className="ax-service-icon">{service.icon}</div>
                <div className="ax-service-info">
                  <h4>{service.title}</h4>
                  <p>{service.desc}</p>
                </div>
                {/* <div className="ax-service-arrow">❯</div> */}
              </div>
            ))}
          </div>
        </div>

        {/* Right Section */}
        <div className="ax-image-container">
          {/* <div className="ax-floating-badge">👥</div> */}
          <div className="ax-main-image-frame">
            <img 
              src="/assets/images/img8.webp" 
              alt="Team working together" 
               loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Service;